// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import * as React from "react";
import { useScrollTrigger } from "@mui/material";
import { Slide } from "@mui/material";
//import { Transition } from "react-transition-group";
import PropTypes from "prop-types";

const HideOnScroll = React.forwardRef((props, ref) => {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide
      ref={ref}
      appear={false}
      direction="down"
      timeout={0}
      in={!trigger}>
      {children}
    </Slide>
  );
});

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
};

export default HideOnScroll;
